var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendMisReportGradient(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_7928)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 49.0234C38.2678 49.0234 49.0234 38.2678 49.0234 25C49.0234 11.7322 38.2678 0.976562 25 0.976562C11.7322 0.976562 0.976562 11.7322 0.976562 25C0.976562 38.2678 11.7322 49.0234 25 49.0234Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_27_7928)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.666 9.00015C31.0313 8.98984 29.4387 9.51865 28.1348 10.5047C26.9796 11.3931 26.0979 12.5888 25.5905 13.9548H12.4538C12.3113 13.9611 12.1767 14.0221 12.078 14.1252C11.9794 14.2283 11.9244 14.3655 11.9245 14.5082L11.7997 33.0748H8.05498C7.98609 33.0717 7.91728 33.0824 7.85254 33.1062C7.78781 33.1299 7.72845 33.1663 7.6779 33.2132C7.62736 33.2602 7.58664 33.3166 7.55811 33.3794C7.52958 33.4422 7.51381 33.51 7.51172 33.579V35.9307C7.5181 36.9981 7.93307 38.0224 8.67136 38.7933C9.40965 39.5641 10.4152 40.0229 11.4812 40.0753V40.0873H27.8226V40.072C27.9549 40.0772 28.0144 40.0873 28.0932 40.0873H28.1045C29.2055 40.0843 30.2605 39.6451 31.0384 38.8658C31.8163 38.0866 32.2537 37.0309 32.2549 35.9298V24.0169C32.3872 24.0242 32.5283 24.0289 32.6645 24.0289C34.6574 24.0291 36.5688 23.2376 37.9781 21.8285C39.3875 20.4195 40.1794 18.5083 40.1796 16.5153C40.1799 14.5224 39.3884 12.611 37.9793 11.2016C36.5703 9.79227 34.659 9.00037 32.6661 9.00015H32.666ZM8.57031 35.9301V34.1333H23.9191V35.9224C23.9191 37.1456 24.4771 38.2351 25.3317 39.0291H11.679C10.8568 39.0271 10.0687 38.7003 9.48642 38.1198C8.90413 37.5394 8.57485 36.7523 8.57031 35.9301ZM28.1003 39.029H28.0931C28.027 39.029 27.945 39.023 27.8685 39.0181C27.0853 38.9611 26.3525 38.6105 25.8166 38.0366C25.2807 37.4627 24.9812 36.7076 24.9778 35.9224V33.5787C24.9801 33.5117 24.9685 33.4451 24.9439 33.3828C24.9192 33.3206 24.8821 33.264 24.8347 33.2167C24.7872 33.1694 24.7306 33.1324 24.6683 33.1079C24.606 33.0835 24.5393 33.0721 24.4724 33.0745H12.8582L12.9794 15.0133H25.2974C25.2028 15.5087 25.1541 16.0118 25.1519 16.5162C25.1578 17.5697 25.3763 18.6113 25.7943 19.5784L16.1813 19.5443C16.1112 19.5433 16.0416 19.5563 15.9766 19.5825C15.9116 19.6087 15.8524 19.6475 15.8024 19.6967C15.7525 19.746 15.7129 19.8046 15.6858 19.8693C15.6588 19.934 15.6449 20.0034 15.6449 20.0735C15.6449 20.1437 15.6588 20.2131 15.6858 20.2777C15.7129 20.3424 15.7525 20.4011 15.8024 20.4503C15.8524 20.4996 15.9116 20.5384 15.9766 20.5646C16.0416 20.5908 16.1112 20.6037 16.1813 20.6028L26.369 20.6369C26.914 21.475 27.6225 22.1946 28.4519 22.7526C29.2814 23.3107 30.2149 23.6958 31.1966 23.8848V35.9296C31.1957 36.7508 30.8693 37.5382 30.2889 38.1192C29.7085 38.7002 28.9215 39.0273 28.1003 39.029ZM32.666 22.9703C32.3763 22.9705 32.0868 22.9511 31.7997 22.9124H31.7988C30.1389 22.6872 28.6314 21.8259 27.5945 20.5102C26.5577 19.1945 26.0726 17.5274 26.2418 15.8609C26.4109 14.1943 27.221 12.6586 28.5011 11.5781C29.7811 10.4976 31.4309 9.95668 33.1023 10.0696C34.7736 10.1826 36.3356 10.9405 37.4586 12.1835C38.5816 13.4264 39.1777 15.0571 39.1211 16.7313C39.0645 18.4055 38.3595 19.9921 37.1551 21.1563C35.9506 22.3205 34.341 22.9712 32.6658 22.9709L32.666 22.9703Z",
    fill: "#5B6DC6"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_27_7928)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5486 25.6055H16.526C16.0694 25.6055 15.6992 25.8424 15.6992 26.1347C15.6992 26.427 16.0694 26.664 16.526 26.664H27.5486C28.0054 26.664 28.3755 26.427 28.3755 26.1347C28.3755 25.8424 28.0054 25.6055 27.5486 25.6055Z",
    fill: "#4A5691"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_27_7928)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.8728 15.2373H35.0882C35.0223 14.9718 34.9105 14.72 34.7579 14.493H35.8728C35.9495 14.4958 36.026 14.4832 36.0977 14.4558C36.1694 14.4285 36.2349 14.3871 36.2903 14.334C36.3457 14.2808 36.3899 14.2171 36.4202 14.1466C36.4505 14.0761 36.4663 14.0002 36.4667 13.9234C36.4671 13.8467 36.452 13.7706 36.4225 13.6998C36.3929 13.629 36.3494 13.5648 36.2945 13.5111C36.2397 13.4575 36.1746 13.4153 36.1032 13.3873C36.0317 13.3592 35.9554 13.3458 35.8787 13.3479H31.3065C31.2301 13.3459 31.154 13.3592 31.0828 13.3871C31.0116 13.4149 30.9466 13.4568 30.8919 13.5102C30.8371 13.5635 30.7936 13.6273 30.7638 13.6978C30.7341 13.7682 30.7188 13.8439 30.7188 13.9204C30.7188 13.9969 30.7341 14.0726 30.7638 14.143C30.7936 14.2135 30.8371 14.2773 30.8919 14.3307C30.9466 14.384 31.0116 14.4259 31.0828 14.4538C31.154 14.4816 31.2301 14.495 31.3065 14.493H32.6161C32.872 14.4861 33.1246 14.5525 33.3441 14.6844C33.5635 14.8163 33.7407 15.0081 33.8548 15.2373H31.306C31.2293 15.2349 31.1528 15.2478 31.0812 15.2755C31.0096 15.3032 30.9443 15.345 30.8892 15.3984C30.834 15.4518 30.7902 15.5157 30.7602 15.5864C30.7303 15.6571 30.7148 15.7331 30.7148 15.8099C30.7148 15.8866 30.7303 15.9626 30.7602 16.0333C30.7902 16.104 30.834 16.168 30.8892 16.2214C30.9443 16.2748 31.0096 16.3166 31.0812 16.3442C31.1528 16.3719 31.2293 16.3849 31.306 16.3824H33.8548C33.7817 16.5133 33.6926 16.6344 33.5894 16.7432C33.3277 16.9899 32.9816 17.1272 32.6219 17.1268H31.3123C31.1558 17.1268 31.0058 17.1889 30.8952 17.2995C30.7846 17.4101 30.7224 17.5601 30.7224 17.7165C30.724 17.7939 30.7409 17.8702 30.7723 17.941C30.8037 18.0118 30.8489 18.0756 30.9052 18.1287L34.1736 21.1345C34.2861 21.2412 34.4356 21.3002 34.5907 21.2991C34.7457 21.298 34.8944 21.237 35.0054 21.1287C35.0596 21.0762 35.1025 21.0132 35.1317 20.9436C35.1608 20.874 35.1756 20.7992 35.175 20.7238C35.1745 20.6483 35.1586 20.5738 35.1285 20.5046C35.0983 20.4355 35.0544 20.3731 34.9995 20.3214L34.9818 20.3042L32.7814 18.2827C33.3951 18.2468 33.9752 17.9907 34.4153 17.5615C34.7503 17.2419 34.9859 16.8324 35.0936 16.382H35.8728C35.9495 16.3845 36.026 16.3715 36.0976 16.3438C36.1692 16.3162 36.2345 16.2744 36.2897 16.221C36.3448 16.1676 36.3887 16.1036 36.4186 16.0329C36.4486 15.9622 36.464 15.8862 36.464 15.8095C36.464 15.7327 36.4486 15.6567 36.4186 15.586C36.3887 15.5153 36.3448 15.4514 36.2897 15.398C36.2345 15.3446 36.1692 15.3028 36.0976 15.2751C36.026 15.2475 35.9495 15.2345 35.8728 15.2369V15.2373Z",
    fill: "#BF6087"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_27_7928",
    x: 1.51172,
    y: 6,
    width: 44.668,
    height: 43.0859,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27_7928"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27_7928",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_27_7928",
    x: 9.69922,
    y: 22.6055,
    width: 24.6758,
    height: 13.0586,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27_7928"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27_7928",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_27_7928",
    x: 24.7148,
    y: 10.3477,
    width: 17.75,
    height: 19.9531,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27_7928"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27_7928",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_7928"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMisReportGradient);
export default __webpack_public_path__ + "static/media/send_mis_report_gradient.77bb85100ae8f9949ba58ea67c64f712.svg";
export { ForwardRef as ReactComponent };